import { render, staticRenderFns } from "./YagiofferTerms.vue?vue&type=template&id=389a3786&"
import script from "./YagiofferTerms.vue?vue&type=script&lang=js&"
export * from "./YagiofferTerms.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports